import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { Dialog } from '@mui/material';
import CloseIcon from '../../../assets/icons/CloseIcon';
// import Api from '../../Api';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/lab/Alert';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete';
import InputLabel from '@mui/material/InputLabel';
import {BsPlusSquareFill} from 'react-icons/bs'
import {TiDelete} from 'react-icons/ti'

import Spinner from "../../Common/Spinner/Spinner";
import { Box } from "@mui/material"
import CropImg from "../../Common/ImgCrop/crop"
import "./QuestionsManagement.scss"
import {makeStyles} from '@mui/styles'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    paper: {
        width : '30%!important',
        maxWidth : '30%!important',
    },
    '@media (max-width:780px)':{
      paper: {
        width : '90% !important',
        maxWidth : '90% !important',
      },
    }
  }));

const AddQuestionPopup = ({ open, setOpen }) => {
    const classes = useStyles()
    const [formData, setFormData] = useState({
        description: '',
        type: 'normal',
        category: '',
        youtubeLink: '',
        keywords: '',
        file:'',
        poll_choices : ["",""]
    });
    const [pollCount,setPollCount] = useState(2) // Count starts from 0
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('');
    const [openMessage, setOpenMessage] = useState(false);
    const [error, setError] = useState('');
    const [descLength,setDescLength] = useState(0)
    const [loading, setloading]= useState(false);
    const [fileCrop, setFileCrop] = useState();

const [searchphrase, setsearchphrase] = useState('');


    const { name, description, type, internal_url, file, external_url } = formData;



// useEffect(()=>{
//   getcities();
// },[])



    const handleChange = (e) => {
      let value = e.target.value
      let name = e.target.name

      let poll_name = name?.split('$$')[0]
      if (poll_name && poll_name === 'poll'){
        let poll_index = name.split('$$')[1]
        let temp = formData.poll_choices
        temp[poll_index] = value
        setFormData({...formData,poll_choices:temp})
        return
      }

      if (name === 'description'){
        setDescLength(value.length)
      }
      setFormData({...formData,[name]:value})
    }

    const handleClose = () => {
        setOpenMessage(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData(e.currentTarget);

        data.append("file", fileCrop);
        data.delete("crop-in");

        
    };

    const clearData = () => {
      setFileCrop()
      setOpen(false)
      
        setFormData({
            description: '',
            type: '',
            category: '',
            youtubeLink: '',
            keywords: '',
            file:''
        });
    };

    const addChoice = () => {
      setPollCount(pollCount+1)
      setFormData({...formData,poll_choices:formData.poll_choices.push("")})

    }
    const removeChoice = () => {
      setPollCount(pollCount-1)
      setFormData({...formData,poll_choices:formData.poll_choices.pop()})
    }

    
    useEffect(() => {
      setFileCrop()
    },[open])

    const setFileData =(data)=>{
      setFileCrop(data);
    }

    const handleTypeChange = (e) => {
      setFormData({...formData,type:e.target.value})
    }

    const types = ['normal', 'polling'];
    
    return (
         <Dialog classes={{paper: classes.paper}} open={open} onClose={() => setOpen(false)}  disableEnforceFocus>
           <div className="popupForm px-42 py-24 popupAdd">
             <div className="flex justify-between items-center mb-10">
               <h3 className="weight-500 text-18">Edit Question</h3>
               <div
                 className="popupClose cursor-pointer"
                 onClick={() => setOpen(false)}
               >
                 <CloseIcon />
               </div>
             </div>
             <form onSubmit={handleSubmit}>
               <div className=" weight-500 text-16 flex flex-col">

                <TextField
                   id="combo-box-demo"
                   name="type"
                   label="Question Type"
                   sx={{
                     marginBottom:2,

                   }}
                   value={formData.type}
                   select
                   onChange={handleTypeChange}
                   variant="standard"
                >
                    <MenuItem value={"normal"} key={"normal"}>Normal</MenuItem>
                    <MenuItem value={"poll"} key={"poll"}>Poll</MenuItem>

                </TextField>


                 <TextField
                   id="outlined-basic"
                   label="Description"
                   variant="outlined"
                   name="description"
                   placeholder="Enter Question Description"
                   helperText={`Characters ${descLength}/${250}`}
                   inputProps={{ maxLength: 250 }}
                   multiline
                   required
                   rows={5}
                   maxRows = {10}
                   sx={{
                     marginBottom:2
                   }}
                   onChange={handleChange}
                 />

                <Autocomplete
                   disablePortal
                   id="combo-box-demo"
                   name="type"
                   options={types}
                   sx={{
                     marginBottom:2,

                   }}
                   renderInput={(params) => <TextField {...params} label="Select Category" value={params} name="type" />}
                 />
                 

                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={["history","politics","science","geography"]}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        variant="standard"
                        label="Keywords Associated"
                        placeholder="Keywords"
                        />
                    )}
                />

                 <Box sx={{
                   marginBottom:2,
                   zIndex:100
                 }}>
                   
                 </Box>

                 <TextField
                   id="outlined-basic"
                   label="Youtube Link"
                   variant="outlined"
                   name="youtubeLink"
                   placeholder="https://www.youtube.com/watch?v=ScMzIvxBSi4"
                   sx={{
                     marginBottom:2
                   }}
                   onChange={handleChange}
                   error = {formData.youtubeLink !== "" && !(/http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/).test(formData.youtubeLink)}
                   helperText={formData.youtubeLink !== "" && !(/http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/).test(formData.youtubeLink)?"Invalid Link":""}
                 />

                 {formData.type === 'poll'?
                   <InputLabel className="mb-2 mt-2 text-18 pollLabel">
                     <div className='pollText'>Poll Choices </div>
                     <Button className="addChoiceButton" variant="contained" onClick={addChoice}>
                       Add Choice <BsPlusSquareFill className="addChoiceIcon"  />
                     </Button>
                  </InputLabel>
                :null}
                 {formData.type === 'poll'?
                 [...Array(pollCount).keys()].map((no) => (
                   <span className="flex">
                    <TextField 
                      defaultValue={formData.poll_choices[no]??""}
                      label = {`Poll Choice ${no+1}`}
                      placeholder = {`Choice ${no+1}`}
                      name={`poll$$${no}`}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{
                        marginBottom:1,
                        width:"calc(100% - 38px)",
                  
                      }}
                      size="small" 
                      required
                    />
                    {no+1 === pollCount && (no+1)>2? <>
                    <TiDelete className="removeChoiceIcon" onClick={removeChoice}/>
                    </>:null}
                    </span>
                 ))
                :null}

                
                 {/* <input type="file" onChange={(e) => uploadFile(e)} />
                 {fileMessage !== '' && (<p style={{ fontSize: '14px', color: "red" }} >{ fileMessage}</p>)} */}
                  {/* {fileCrop?
                    <div style={{width:"100%",marginBottom:20}}>
                      <img src={URL.createObjectURL(fileCrop)} width="100%" height="250px" alt="Promo img" />
                    </div>
                  :null}
                 <CropImg setFileData={setFileData} aspect={16/9}/> */}
                 <Button
                    variant="contained"
                    component="label"
                    >
                    Upload File
                    <input
                    type="file"
                    hidden
                    />
                </Button>
                 {error && (<p style={{ fontSize: '14px', color: "red" }} >{error}</p>)}
               </div>
               <div className="flex justify-between mt-30 promo-popup-btns">
                 <Button
                   variant = "contained"
                   type="button"
                   style={{ marginRight: '20px',backgroundColor:"#42da93",color:"#fff" }}
                   onClick={() => clearData()}
                 >
                   Discard Details
                 </Button>
                 <Button
                   style={{ backgroundColor:"#42da93",color:"#fff" }}
                   type="submit"
                 >
                   Create Promo
                 </Button>
               </div>
            </form>

            <Snackbar
              open={openMessage}
              autoHideDuration={5000}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              <Alert onClose={handleClose} severity={severity}>
                {message}
              </Alert>
            </Snackbar>
          </div>
        </Dialog>
    );
};

export default AddQuestionPopup;
